import StaticContentNavigation from 'navigation/StaticContentNavigation/StaticContentNavigation';
import { FC, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { IStaticContentFiltersFormValues } from '../ModalView/StaticContentFiltersModal/StaticContentFiltersForm/StaticContentFiltersForm';
import styles from './StaticContent.module.scss';
import { StaticContentContext } from './StaticContentContext/StaticContentContext';

const StaticContent: FC = () => {
  const [filters, setFilters] = useState<IStaticContentFiltersFormValues>({});

  const updateFilters = (values: IStaticContentFiltersFormValues) => {
    setFilters(values);
  };

  return (
    <StaticContentContext.Provider value={{ filters, updateFilters }}>
      <div className={styles.container}>
        <h1 className={styles.heading}>Skills</h1>
        <StaticContentNavigation />
        <Outlet />
      </div>
    </StaticContentContext.Provider>
  );
};

export default StaticContent;
